
export class ReleaseDateFilter {

    from: Date;
    to: Date;

}
